<div class="main-container">
  <!--
    **
    * Simple Confirm Account Top Section
    **
   -->
  <ng-template [ngIf]="!singUpProcess">
    <section class="top-section">
      <cp-logo></cp-logo>
    </section>
    <!-- <section class="back-home-section">
      <go-back (click)="back()"></go-back>
    </section> -->
     <div class="back-home-section">
  <div class="back-button" (click)="back()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="back-icon">
      <path d="M15.5 18L9.5 12L15.5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="back-text">Back to home</span>
  </div>
</div>
  </ng-template>
  <!-- <section class="log-out">
    <label for="" class="email">{{ currentUser.email }}</label>
    <span (click)="logOut()"> Log out </span>
    <mat-icon class="user-icon" mat-raised-button (click)="openBottomSheet()"
      >person</mat-icon
    >
    <ng-template let-bottomSheetRef="bottomSheetRef" #templateBottomSheet>
      <div class="bottom-sheet">
        <div class="">
          <label for="">{{ currentUser.email }}</label>

          <gbui-button (click)="logOut()" class="">Log out</gbui-button>
        </div>
      </div>
    </ng-template>
  </section> -->
  <!--
    **
    * Confirm Account For Sing Up  Top Section
    **
   -->
  <ng-template [ngIf]="singUpProcess">
    <section class="top-section-sing-up">
       <go-back class="d-b-m" (click)="goBack()"></go-back>
      <img src="/assets/logo/logo-full-green.png" alt="" />
    </section>

    <section class="slide-container">
      <img src="/assets/sing-up/2.png" alt="" />
    </section>
    <section class="">
      <go-back class="d-n-s" (click)="goBack()"></go-back>
    </section>
  </ng-template>

  <div class="flow-container">
    <div class="">
      <section class="set-code-container" [formGroup]="form">
        <h1>Confirm Your Account</h1>
        <h3 *ngIf="!isMobile">Insert the confirm account code you received in your email.</h3>
        <label for="">Code</label>
        <ng-otp-input
          (onInputChange)="onOtpChange($event)"
          #ngOtpInput
          [config]="{ length: 6 }"
        ></ng-otp-input>
        <p for="">
          Didn’t receive a code?&nbsp;
          <ng-template [ngIf]="(resendEmailLoading$ | async) ?? false">
            <mat-spinner [diameter]="20" class="mat-spinner-green">
            </mat-spinner>
          </ng-template>
          <ng-template
            [ngIf]="!(resendEmailLoading$ | async)"
            [ngOutletContext]="context"
          >
            <span (click)="sendAgain()">Send Again</span>
          </ng-template>
        </p>
        <gbui-button
          [busy]="confirmAccountLoading$ | async"
          (click)="checkCode()"
          [disabled]="form.invalid"
          class="buttons-outline"
          type="submit"
        >
          Submit
        </gbui-button>
      </section>
    </div>
  </div>
</div>
